<template>
  <div>
    <v-dialog
      v-model="isInfoDialogOpen"
      max-width="650px"
      @click:outside="$emit('update:is-info-dialog-open', false)"
    >
      <v-card class="pa-sm-10 pa-3">
        <v-card-title class="justify-center text-h5">
          Editar informações de Equipe
        </v-card-title>

        <v-card-text class="mt-5">
          <v-form class="multi-col-validation">
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="equipeDataLocale.nome"
                  outlined
                  dense
                  label="Nome"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="equipeDataLocale.idGestorPrincipal"
                  :items="gestores"
                  :loading="isLoadingGestores"
                  :search-input.sync="search"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  hide-details="auto"
                  hide-no-data
                  placeholder="Gestor Principal"
                  label="Gestor Principal"
                  class="mb-6"
                  @change="modalConfirmarGestor"
                />
              </v-col>

              <v-col
                cols="12"
                sm="12"
              >
                <v-textarea
                  v-model="equipeDataLocale.descricao"
                  outlined
                  dense
                  label="Descrição"
                  hint="Máximo de 150 caracteres"
                  auto-grow
                ></v-textarea>
              </v-col>

              <v-col
                cols="12"
                class="d-flex justify-end"
              >
                <v-btn
                  outlined
                  class="me-3"
                  color="secondary"
                  @click="$emit('update:is-info-dialog-open', false)"
                  @click.prevent="resetForm"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="update"
                >
                  Salvar alterações
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="modalTrocaGestor"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          Modificação
        </v-card-title>
        <v-card-text>
          Confirma modificar o gestor {{ equipeDataLocale.nomeGestorPrincipal }}?
          Essa ação vai associar todos os agentes cadastrados na equipe para o gestor selecionado.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="cancelaModalGestor"
          >
            Não
          </v-btn>
          <v-btn
            color="success"
            @click="modalTrocaGestor = false"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from '@core/utils/validation'
import { ref, watch } from '@vue/composition-api'
import EquipeService from '@/services/modules/EquipeService'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    isInfoDialogOpen: {
      type: Boolean,
      required: true,
    },
    equipeData: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    modalTrocaGestor: false,
    gestores: [],
    isLoadingGestores: false,
    search: null,
  }),

  watch: {
    isInfoDialogOpen(val) {
      if (val) this.carregarGestores()
    },

    async search(val) {
      await this.carregarGestores(val)
    },
  },

  methods: {
    async carregarGestores(nome = null) {
      try {
        this.isLoadingGestores = true
        this.gestores = await ColaboradorService.get(nome, true, null, 1)
      } finally {
        this.isLoadingGestores = false
      }
    },

    async update() {
      const data = this.equipeDataLocale
      await EquipeService.atualizar(data.id, {
        nome: data.nome,
        descricao: data.descricao,
        idGestorPrincipal: data.idGestorPrincipal,
      })
      this.$emit('refresh-data')
      this.$emit('update:is-info-dialog-open', false)
    },

    modalConfirmarGestor() {
      this.modalTrocaGestor = true
    },

    cancelaModalGestor() {
      this.modalTrocaGestor = false
      this.resetForm()
    },
  },

  setup(props, { emit }) {
    const equipeDataLocale = ref(props.equipeData)

    const resetForm = () => {
      equipeDataLocale.value = JSON.parse(JSON.stringify(props.equipeData))
    }

    const editarEquipe = () => {
      emit('update:is-info-dialog-open', false)
    }

    watch(
      () => props.isInfoDialogOpen,
      () => {
        equipeDataLocale.value = JSON.parse(JSON.stringify(props.equipeData))
      },
    )

    return {
      equipeDataLocale,
      editarEquipe,
      resetForm,
      validators: { required },
    }
  },
}
</script>
